import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Typography,
  Collapse,
  CardContent,
  FormControlLabel,
  Checkbox,
  Chip,
  LinearProgress,
  ClickAwayListener,
  Tooltip 
} from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import cx from 'classnames';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import _ from 'lodash';
import dateService from '../../common/services/dateService';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { contentRequestAccordianActions } from "../reducers/contentRequestAccordianState";
import { Priority, PriorityColors, PriorityTitle } from "../types/Constants";
import { getAuthUserClientId, isLoggedInUserCenterHead, isLoggedInUserMultiCenterHead } from '../helpers/createContentRequest'
import { ContentRequest,Owners, RequestInfoDetails } from "../types/ContentRequest";
import { deleteContentRequest, getReceivedContentRequest } from "../actions/contentRequestActions";
import { Tabs } from "../types/Constants";
import ACLService from '../../acl/services/aclService';
import { MyPATDialog } from "../../common";
import { Subject } from "../../course/modals/CourseBasicInfo";
import { selectAllCheckbox } from "../../mylibrary/reducers/bulkimportReducer";
import { formatDistanceToNow } from "date-fns";
import { is } from "date-fns/locale";
interface RequestCardProps extends WithStyles<typeof userStyles>, RouteComponentProps {
  data: ContentRequest;
  requestType: string;
	selectAllCheckbox: Function,
  setAccordianState: Function,
  setAccordingTouchIndex: Function,
  setIsTabOpened: Function,
  showDate: boolean,
  deleteContentRequest: Function,
  activeTab: any,
  setTestAccordian: Function,
  setIsBothTabOpen: Function,
  getReceivedContentRequest: Function,
  user: any,
}

interface RequestCardState {
  expandedFilter: boolean;
  filterItems: Array<string>;
  isCustomDropdown: boolean;
  isDeleteRequest:boolean;
  isDeleteRequestPopup:boolean
}

class RequestCard extends Component<RequestCardProps, RequestCardState> {
  isCenterHead:boolean;
  isMultiCenterHead:boolean;
  constructor(props: RequestCardProps) {
    super(props);
    this.state = {
      expandedFilter: true,
      isCustomDropdown: false,
      filterItems: ["Important and urgent", "Not important but urgent", "Important but not urgent", "Not important and not urgent"],
      isDeleteRequest:false,
      isDeleteRequestPopup:false
    };
    this.isCenterHead = isLoggedInUserCenterHead();
    this.isMultiCenterHead = isLoggedInUserMultiCenterHead();
    this.getAllAssignorsName=this.getAllAssignorsName.bind(this);
  }
  filterExpandClick = (value: any) => {
    this.setState({
      expandedFilter: !this.state.expandedFilter
    })
  }

  // if(_.get(this.props.data, 'requestInfo.details.testDetails.authors[0].type', '') === 'creator'){
  checkAuthorTypeTest = () => {
    const testDetails = _.get(this.props.data, 'requestInfo.details.testDetails', '');
    let isCreator = false;
    if (testDetails.authors) {
      if (testDetails.authors && testDetails.authors.length > 0) {
        testDetails.authors.forEach((author: any) => {
          if (author.type === 'creator') {
            isCreator = true;
          }
        })
      }

    }
    return isCreator;
  }

  // if(_.get(this.props.data, 'requestInfo.details.subjects[0].questions[0].authors[0].type', '') === 'creator'){
  checkAuthorTypeQuestion = () => {
    const questionDetails = _.get(this.props.data, 'requestInfo.details', '');
    let isCreator = false;

    if (questionDetails.subjects) {
      if (questionDetails.subjects.authors && questionDetails.subjects.authors.length > 0) {
        questionDetails.subjects.authors.forEach((author: any) => {
          if (author.type === 'creator') {
            isCreator = true;
          }
        })
      }

    }
    return isCreator;
  }

  checkContentOwnerRoleForCreator = () => {
    const type = this.props.data.requestInfo.type;
    if (type === 'test') {
      // if(_.get(this.props.data, 'requestInfo.details.testDetails.authors[0].type', '') === 'creator'){
      if (this.checkAuthorTypeTest() || this.checkAuthorTypeQuestion()) {
        return true
      }
    }
    else {
      // if(_.get(this.props.data, 'requestInfo.details.subjects[0].questions[0].authors[0].type', '') === 'creator'){

      if (this.checkAuthorTypeQuestion()) {
          return true;
      }
    }
    return false;
  }

  handleRequestEdit = (requestId: string, requestType: string) => {
    this.props.history.push(`/contentRequest/edit/${requestType}/${requestId}`)
  }

  checkIfStatusIsDraft = (data: any) => {
    if(data.status === 'draft'){
      return true;
    } else {
      return false;
    }
  }

  checkLoggedInUserAndRequestCreator = (data: any) => {
    const userD = ACLService.getUserDetailsFromStorage();
    const createdByUserEmail = _.get(data, 'aclMetadata.createdBy.email', '');
    const loggedInUserEmail = _.get(userD,"authenticatedUser.aclMetadata.createdBy.email",'');
    if(createdByUserEmail === loggedInUserEmail){
      return true
    } else {
      return false
    }
  }


  checkIfLoggedinUserIsInOwnersList = () => {
    const userD = ACLService.getUserDetailsFromStorage();
    const clientId = _.get(userD, 'authenticatedUser.aclMetadata.clientId._id', '')
    const owners = _.get(this.props.data.requestInfo, 'owners', []);
    owners.forEach((owner: any) => {
      if(owner.client){
        if(owner.client.id === clientId){
          return true;
        }
      }
    })

    return false;
  }





  checkIfLoggedInUserIsAuthor = () => {
    const userD = ACLService.getUserDetailsFromStorage();
    const userId = _.get(userD, 'authenticatedUser._id', '')
    const requestDetails = _.get(this.props.data, 'requestInfo.details', {});
   

    if (requestDetails.subjects) {
      if (requestDetails.subjects.authors && requestDetails.subjects.authors.length > 0) {

          return true;

      }

    }

    const authors = _.get(this.props.data, 'requestInfo.details.testDetails.authors', []);
      if (authors.length > 0) {
         
        return true;

      }

    return false
  }
  

  handleRequestCard = () => {
    const isCenterHead = this.isCenterHead;
    const isMultiCenterHead = this.isMultiCenterHead;
    // const isAdmin = 
    let { requestType, data } = this.props;
    const isLoggedInUserAuthor = this.checkIfLoggedInUserIsAuthor()
    // /contentRequest/owner-task/:contentRequestId/:role
    if (requestType === "received") {

      if(isCenterHead || isMultiCenterHead){
        this.handleRedirectionForCenterHead(data, isLoggedInUserAuthor);
      } 


      if(!isCenterHead && !isMultiCenterHead){
        this.handleRedirectionForContentAuthor(data);
      }

    }

    if (requestType === "sent") {
      if(data.status === 'draft'){
        this.props.history.push(`/contentRequest/edit/${data.requestInfo.type}/${data._id}`);
      } else {
        this.props.history.push(`/contentRequest/${data._id}`);
      }
    }

  }

  componentDidMount = () => {
    const { setAccordianState, setAccordingTouchIndex, setIsTabOpened, setIsBothTabOpen, setTestAccordian ,selectAllCheckbox } = this.props;
    setAccordianState([]);
    setAccordingTouchIndex([{ questionContent: [] }])
    setTestAccordian([{
      testContent: []
    }])
    setIsTabOpened({ booleanValue: false });
		setIsBothTabOpen({ booleanValue: false })
		selectAllCheckbox({
			item: []
			});
			
  }
  handleOnClick = () => {
    const { data, history } = this.props;
    const { _id } = data;
    history.push(`/contentRequest/owner-task/${_id}/creator`);
  }

  handleRequestAction = (event: any) => {
    this.setState({ isCustomDropdown: !this.state.isCustomDropdown })
    event.stopPropagation();
  }

  handleRedirectionForCenterHead(data: ContentRequest, isLoggedInUserAuthor: boolean) {
    if ((this.checkIfAnyOwnerInDraft(data))) {
      this.props.history.push(`/contentRequest/${data.requestInfo.type}/${data._id}/edit`);
    } else if (!isLoggedInUserAuthor) {
      this.props.history.push(`/contentRequest/${data._id}`);
    } else {
      this.handleRedirectionForContentAuthor(data);
    }
  }

   handleRedirectionForContentAuthor(data: ContentRequest) {
    if ( this.checkContentOwnerRoleForCreator()) {
      // // If not started, then move to creator
      this.props.history.push(`/contentRequest/owner-task/${data._id}/creator`);
    } else {
      // else feedback flow
      if (data.requestInfo.type === "test" && data.requestInfo.details.testDetails) {
        const testAuthorType = _.get(data.requestInfo, 'details.testDetails.authors[0].type', 'creator');
        this.props.history.push(`/contentRequest/received/${data._id}/${testAuthorType}`);

      } else {
        this.props.history.push(`/contentRequest/received/${data._id}/${_.get(data.requestInfo.details, 'subjects.authors[0].type', 'creator')}`);
      }

    }
  }

  formatDate(publishedOnDate: string) {
    const publishedDate = new Date(publishedOnDate);
    const day = publishedDate.getDate();
    const month = publishedDate.getMonth() + 1;
    const year = publishedDate.getFullYear();
    return `${day} ${month} ${year}`
  }

  transformPriorityText(priority: any) {
    switch (priority) {
      case 'importantAndUrgent': return PriorityTitle.importantAndUrgent; break;
      case 'notImportantButUrgent': return PriorityTitle.notImportantButUrgent; break;
      case 'importantButNotUrgent': return PriorityTitle.importantButNotUrgent; break;
      case 'notImportantAndNotUrgent': return PriorityTitle.notImportantAndNotUrgent; break;
      default:
    }
  }

  formatPercentage(val: any) {
    return val && !isNaN(val) ? parseInt(val) : "0"
  }


   checkIfDeleteShouldBeDisabled = () => {
    const totalCompleted = _.get(this.props.data,'progress.details.question.roles.creator',[]);
    if(this.props.data) {
       if(this.props.data.completionPercent > 0){
          return true;
       } else {
          return false;
       }
    }
   
   }

   getIconBasedOnPriority = (priorityType: string) => {
     switch(priorityType){
      case 'importantAndUrgent': return '/assets/svg/contentRequest/important_urgent.svg';break;
      case 'notImportantButUrgent': return '/assets/svg/contentRequest/notImportant_urgent.svg';break;
      case 'importantButNotUrgent': return '/assets/svg/contentRequest/important_not_urgent.svg';break;
      case 'notImportantAndNotUrgent': return '/assets/svg/contentRequest/noImportant_noUrgent.svg';break;
      default: return '/assets/svg/contentRequest/defaultpriority.svg';
    }
   }

   truncateExtraText = (title: string) => {
     let updatedTitle;
    if(title && title.length > 40){
      updatedTitle = title.substring(0, 40) + '...'
    } else {
      updatedTitle = title;
    }
     return updatedTitle;
   }

   handleCancleClick=()=>{
    this.setState({
     isDeleteRequest:false
    })
  }
  deleteRequest=()=>{
 this.setState({
   isDeleteRequestPopup:true,
   isDeleteRequest:true
 })
  }

  checkIfAnyOwnerInDraft = (data: any) => {
    const { user } = this.props;
    const userClientIdSet = new Set(_.get(user, 'clients', []).map(({ id }: any) => id));

    let ownerInDraft = false;
    const owners: Owners[] = _.get(data.requestInfo, 'owners', []).filter((owner: Owners) => userClientIdSet.has(owner.client.id));

    if(owners.length > 0) {
      owners.forEach((owner:any) => {
        if(owner.status === 'draft'){
          ownerInDraft = true;
          return ownerInDraft;
        }
      })
    } else {
      ownerInDraft = false
    }

    return ownerInDraft;
   }
  getAllAssignorsName=(data:any)=>{
    const owners=_.get(data, 'requestInfo.owners', []);
    if(owners.hasOwnProperty('client')){
       return owners.client.name;
    }
    if(owners.length==0)
     return "";
    const requestOwnerNames:any=new Set();
    // const requestOwnerNames:any=[];
    for(let owner of owners){
      requestOwnerNames.add(owner.client.name);
      // requestOwnerNames.push(owner.client.name);
    }
    const ownerNamesInArray:any=[... requestOwnerNames];
    let isNamesMoreThan2=ownerNamesInArray.length>2?true:false;
    let namesToReturn=ownerNamesInArray.slice(0,2).join(', ');
     let tooltiptitle='';
     let tooltipDetail='';
    if(isNamesMoreThan2){
      let extraLength=ownerNamesInArray.length-2;
       tooltipDetail=ownerNamesInArray.slice(2,ownerNamesInArray.length).join(' ,');
      tooltiptitle=` +${extraLength}`;
    }
    return <span>{namesToReturn}
             {isNamesMoreThan2 && <Tooltip title={tooltipDetail}>
               <span>{tooltiptitle}</span>
              </Tooltip>}
            </span>;
  }

    getContentRequestForText = () => {
      const {data } = this.props
      const owners:Owners[] = _.get(data, 'requestInfo.owners', [])
      console.log('Owners--------->',owners)
     if(this.isCenterHead) {
        const clientId = getAuthUserClientId();
        const authOwners = owners.filter((owner) => owner.client.id === clientId)
        console.log('AuthOwner', authOwners)
        if(!authOwners.length) return 'N/A';

        const isTestCompiler = authOwners.find((owner) => owner.type === 'test-compiler');
        
        if(isTestCompiler) {
          console.log('In Test')
          return `${_.get(data, 'requestInfo.totalCount','') > 0 ? _.get(data, 'requestInfo.totalCount','') : ''}  Test${_.get(data, 'requestInfo.totalCount','') > 1 ? 's':''}`  
        } else {
          console.log('In Subject')
          return `${_.get(data, 'requestInfo.totalCount','') > 0 ? _.get(data, 'requestInfo.totalCount',''): ''} Question${_.get(data, 'requestInfo.totalCount','') > 1 ? 's':''}`
        }
     }

     if(this.isMultiCenterHead){
      const contentRequestForText = data && _.get(data, 'requestInfo.type','') === 'test'?
      `${_.get(data, 'requestInfo.totalCount','') > 0 ? _.get(data, 'requestInfo.totalCount','') : ''}  Test${_.get(data, 'requestInfo.totalCount','') > 1 ? 's':''}` :
      `${_.get(data, 'requestInfo.totalCount','') > 0 ? _.get(data, 'requestInfo.totalCount',''): ''} Question${_.get(data, 'requestInfo.totalCount','') > 1 ? 's':''}`
      return contentRequestForText;
     }

    }

    getContentRequestDeadlineByAuthorType = (type: string) => {
      const { data } = this.props;
      console.log(':::::::::DATA:::::::::', data);
      const { requestInfo } = data;
      // const { type, details } = requestInfo;

      
      if(type === 'question'){
        const authorType = _.get(data, 'requestInfo.details.subjects.authors[0].type');
        console.log('::::::::::authorType::::::::::',authorType)
        const questionEndDate = _.get(data, `requestInfo.details.subjects.roles.${authorType}.endDate`)
        console.log(':::::::::::endDate:::::::::::', questionEndDate);
        return questionEndDate;
      }


      if(type === 'test'){
        const authorTypeQuestion = _.get(data, 'requestInfo.details.subjects.authors[0].type');
        const questionEndDate = _.get(data, `requestInfo.details.subjects.roles.${authorTypeQuestion}.endDate`)
        const authorTypeTest = _.get(data, 'requestInfo.details.testDetails.authors[0].type')
        const testEndDate = _.get(data, `requestInfo.details.testDetails.roles.${authorTypeTest}.endDate`)
        console.log(':::::::::authorType (Q, T):::::::::;', authorTypeQuestion, authorTypeTest)
        console.log('::::::::questionEndDate::::::', questionEndDate)
        console.log('::::::::testEndDate::::::', testEndDate)
        return {
          questionEndDate: questionEndDate,
          testEndDate: testEndDate
        }
      }

    }

    renderContentRequestFor=()=>{
      // this.getContentRequestForText();
      const {data } = this.props
      const requestData = _.get(data, 'requestInfo.type', '');
      const checkTestTypeData = _.get(data, 'requestInfo.details.testDetails', '');
      const countData = _.get(data, 'requestInfo.totalCount');
      const questionCount = _.get(data, 'requestInfo.details.subjects.authors[0].count');
      const subjects =_.get(data, 'requestInfo.details.subjects.subjects',[]).join(", ");
      let requestAuthorsForTest = _.get(data, 'requestInfo.details.testDetails.authors', []);
      let requestAuthorsForSubject = _.get(data, 'requestInfo.details.subjects.authors', []);
      requestAuthorsForTest = requestAuthorsForTest.filter((authors: any) => authors.type === 'creator')
      requestAuthorsForSubject = requestAuthorsForSubject.filter((authors: any) => authors.type === 'creator')
      
      let questionEndDate;
      if(requestData === 'question'){
        questionEndDate = this.getContentRequestDeadlineByAuthorType(requestData);
      }

      let questionEndDateTest, testEndDateTest;
      if(requestData === 'test'){
        const { questionEndDate, testEndDate } = this.getContentRequestDeadlineByAuthorType(requestData)
        questionEndDateTest = questionEndDate;
        testEndDateTest = testEndDate;
      }
      

  if(this.isCenterHead || this.isMultiCenterHead){
    return(
  <Grid container justify="space-between">
  <Grid item>
  <Grid className="verticleSpacing">
      <span>Content Request for:</span>
      <span>{this.getContentRequestForText()}</span>
    </Grid>
    </Grid>
    <Grid item xs={4}>
    {subjects && <Grid item>
          <span>For Subject:&nbsp;</span>
          <span>{data && subjects}</span>
        </Grid>}
    </Grid>
    <Grid item xs={4} className="pushRight">
    <Grid item>
    <Grid className="verticleSpacing">
      <span>Deadline:&nbsp;</span>
      <span>{data && dateService.dateFromString(data.requestInfo.endDate)}</span>
      </Grid>
    </Grid>
    </Grid>
    </Grid>
    )
  }else{
    return(
      <>
      {requestData === 'question' || (requestData === 'test' && checkTestTypeData === '') ?
      
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
        <Grid className="verticleSpacing">
          <span>Request for: Content Creation, &nbsp;</span>
          <span> {questionCount}{questionCount>1?` Questions`: ` Question`}</span>
          </Grid>
        </Grid>
        {subjects && <Grid item>
          <Grid className="verticleSpacing">
          <span>For Subject:&nbsp;</span>
          <span>{data && subjects}</span>
          </Grid>
        </Grid>}
        <Grid item>
        <Grid className="verticleSpacing">
          <span>{questionEndDate !== undefined ? `Deadline:` : ''}&nbsp;</span>
          <span>{questionEndDate !== undefined ? dateService.dateFromString(questionEndDate) : ''}</span>
        </Grid>
        </Grid>
      </Grid>
      : (<>
        {requestAuthorsForSubject && Boolean(requestAuthorsForSubject.length) && <Grid container justify="space-between" alignItems="center">
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Request 1: Content Creation, &nbsp;</span>
            <span> {questionCount}{questionCount >1?` Questions`: ` Question`}</span>
            </Grid>
          </Grid>
          {subjects && <Grid item>
            <Grid className="verticleSpacing">
            <span>For Subject:&nbsp;</span>
            <span>{data && subjects}</span>
            </Grid>
        </Grid>}
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Deadline:&nbsp;</span>
            <span>{data && dateService.dateFromString(questionEndDateTest)}</span>
            </Grid>
          </Grid>
          <Grid container justify="space-between" alignItems="center">
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Request 2: Test Compilation, &nbsp;</span>
            {/* <span>{`${_.get(data, 'requestInfo.totalCount')} Test`}</span> */}
            <span>{countData>1?`${_.get(data, 'requestInfo.totalCount')} Tests`: `${_.get(data, 'requestInfo.totalCount')} Test`}</span>

            </Grid>
          </Grid>
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Test Type:&nbsp;</span>
            <span>{data && _.get(data, 'requestInfo.details.testDetails.type')}</span>
            </Grid>
          </Grid>
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Deadline:&nbsp;</span>
            <span>{data && dateService.dateFromString(testEndDateTest)}</span>
          </Grid>
          </Grid>
        </Grid>
        </Grid>}
        {(requestAuthorsForSubject && Boolean(requestAuthorsForSubject.length))||(requestAuthorsForTest && Boolean(requestAuthorsForTest.length)) && <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Grid className="verticleSpacing">
            <span>Request for: Test Compilation, &nbsp;</span>
            <span>{countData>1?`${_.get(data, 'requestInfo.totalCount')} Tests`: `${_.get(data, 'requestInfo.totalCount')} Test`}</span>
            </Grid>
          </Grid>
          <Grid item>
            <Grid className="verticleSpacing">
            <span>Test Type:&nbsp;</span>
            <span>{data && _.get(data, 'requestInfo.details.testDetails.name')}</span>
            </Grid>
          </Grid>
          <Grid item>
          <Grid className="verticleSpacing">
            <span>Deadline:&nbsp;</span>
            <span>{data && dateService.dateFromString(testEndDateTest)}</span>
          </Grid>
          </Grid>
        </Grid>
        }
      </>
      )
  }
   </> 
    )
}
  }

  render() {
    const { classes, data, requestType } = this.props;
    const { expandedFilter, filterItems, isCustomDropdown,isDeleteRequest,isDeleteRequestPopup } = this.state;
    const requestData = _.get(data, 'requestInfo.type', '');
    const userD = ACLService.getUserDetailsFromStorage();
    const authenticatedUser=_.get(userD,"authenticatedUser",{});
    let requestAuthorsForTest = _.get(data, 'requestInfo.details.testDetails.authors', []);
    let requestAuthorsForSubject = _.get(data, 'requestInfo.details.subjects.authors', []);
    requestAuthorsForTest = requestAuthorsForTest.filter((authors: any) => authors.type === 'creator')
    requestAuthorsForSubject = requestAuthorsForSubject.filter((authors: any) => authors.type === 'creator')
    const subjects =_.get(data, 'requestInfo.details.subjects.subjects',[]).join(",");
    return (
      <>
        {this.props.showDate && <Grid container>
          <Grid item>
            <span className={classes.dateLabelText}> {data && data.createdAt && dateService.dateFromString(data.createdAt)}</span>
          </Grid>
        </Grid>}
        {isDeleteRequestPopup && 
           <MyPATDialog
           dialogOpen={isDeleteRequest}
           dialogHeading="Delete Request"
           isborderDialogAction={true}
           onDialogClose={this.handleCancleClick}
           isAlignCenter={true}
           otherDialogProps={{
             fullWidth: true,
             maxWidth: 'sm',
           }}
           customDialogActions={
             <>
               <Button color="primary"
                 onClick={this.handleCancleClick}>Cancel</Button>
               <Button
                 variant="contained" color="primary"
                 onClick={() => {  this.props.deleteContentRequest({
                   activeTab: this.props.activeTab,
                   id:data._id
               })
               this.props.getReceivedContentRequest()
               this.handleCancleClick()}}
               >
                 Yes, Delete
               </Button>
             </>
           }
         >
 <Typography align="center">
   <img src="/assets/svg/contentRequest/delete_request.svg"/>
 <Typography className={ cx(classes.fontSize16,classes.marginTop12)}>The content request created by you will be deleted.
Are you sure you want to delete the request?</Typography>
 </Typography>
         </MyPATDialog>
 
         }
        <Card classes={ (data.requestInfo && data.requestInfo.type === 'question') ? 
                        { root: cx(classes.customCard, classes.questionBorder) } : 
                        { root: cx(classes.customCard, classes.testBorder) }} elevation={0} 
          onClick={this.handleRequestCard}
        >
          <CardHeader
            action={
              <>
                <Grid container justify="flex-end" alignItems="center" className={classes.marginTop12}>
                  {requestType === 'sent' && <Grid item>
                    <Grid className="chips">
                      {data && data.status === 'published' && <Chip color="primary"
                        label="Published"
                        className={classes.customChip}
                        classes={{ label: classes.chipLabel }}
                        variant="outlined" />}
                      {/* {data && data.status === 'draft' && <Chip color="primary"
                        label="Draft"
                        className={classes.customChip}
                        classes={{ label: classes.chipLabel }}
                        variant="outlined" />} */}
                    </Grid>
                  </Grid>}
                  {/* @fronted use it for Draft */}

                  {/* End */}
                  {data && data.status === 'draft' && <Grid item>
                    <Grid container justify="flex-end">
                      <Grid item>
                        <span className={classes.progressLabel}>
                          {
                            this.formatPercentage(data.completionPercent) + "%"
                          } Draft:
                        </span>
                      </Grid>
                      <Grid item>
                        <LinearProgress
                          variant="determinate"
                          classes={{
                            colorSecondary: classes.colorSecondary,
                            barColorPrimary: classes.colorSecondary,
                            bar: classes.progressBar, root: classes.linearProgressBar1
                          }}
                          value={parseInt(data.completionPercent.toString())}
                        />
                      </Grid>
                      {/* <Grid item className={classes.resumeButton}>
                        &nbsp;&nbsp; <span>Resume</span> 
                      </Grid>      */}
                    </Grid>
                  </Grid>
                  }

                  <Grid item>
                    <Grid>
                      { 
                    data.status === 'draft' ?
                    data && dateService.timeSince(data.createdAt) :
                    (
                      (data.status === 'published' &&
                        dateService.timeSince(data.publishedOn)
                      ) 
                    )
                    }</Grid>
                  </Grid>
                  {/* <Grid item>
                    <Grid>
                      { 
                    data.status === 'draft' ?
                    data && formatDistanceToNow(new Date(data.createdAt || ''), {includeSeconds: true, addSuffix: false}) :
                    (
                      (data.status === 'published' &&
                        formatDistanceToNow(new Date(data.publishedOn) || '', {includeSeconds: true, addSuffix: false})
                      ) 
                    )
                    }</Grid>
                  </Grid> */}

                  <Grid item className={requestType != 'sent' ? classes.iconWidth : ' '}>
                    {requestType === 'sent' && <IconButton
                      className={classes.expand}
                      aria-expanded={true}
                      aria-label="show more"
                      onClick={this.handleRequestAction}
                    >
                      <MoreVertIcon fontSize="small" height="1em" />
                    </IconButton>}

                  </Grid>
                  {requestType === 'sent' && isCustomDropdown &&
                    <ClickAwayListener onClickAway={this.handleRequestAction}>
                      <Grid className={classes.customDropdownBox}>
                        <Grid className="editAction">
                          <FormControlLabel
                            classes={{ root: [classes.fontSize14, classes.fontWeight400].join(' ') }}
                            control={<EditOutlinedIcon />}
                            label="Edit Request"
                            onClick={(event: any) => {
                              this.handleRequestEdit(data._id || '', data.requestInfo.type);
                              this.handleRequestAction(event)
                            }}
                          />
                        </Grid>
                        {
                          data.status === 'draft' &&
                          <Grid className="deleteAction">
                          <FormControlLabel
                            classes={{ root: [classes.fontSize14, classes.fontWeight400].join(' ') }}
                            onClick={(event: any) => {
                              this.deleteRequest();
                              this.handleRequestAction(event)
                            }}
                            control={
                            // <ClearIcon/>
                            <img src="/assets/svg/delete.svg" style={{margin: '0 12px', width: '20px'}}/>
                          }
                            label="Delete Request"
                            // disabled={this.checkIfDeleteShouldBeDisabled()}
                          />
                        </Grid>
                        }
                        

                      </Grid>
                    </ClickAwayListener>
                  }
                </Grid>
              </>
            }
            title={
              <Typography component="h6" variant="body1" className={classes.cardTitle}>
                <span>{data && data.requestId}</span>&nbsp;|&nbsp;<span>{data && this.truncateExtraText(data.title)} </span>
              </Typography>
            }
            className={classes.cardHeader}
          />
          <CardContent className={classes.requestCardContent}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                {requestType === 'received' && <span  className="verticleSpacing">
                  <span>Assigned by:</span><span> {_.get(data, 'requestInfo.details.subjects.assignor.name', _.get(data,'aclMetaData.createdBy.id.fullName',''))}&nbsp; on {dateService.dateFromString(_.get(data, 'createdAt', ''))}</span>
                  
                  </span>}
                {requestType === 'sent' && <span className="verticleSpacing">
                  <span>Assigned to:</span><span>{this.getAllAssignorsName(data)}</span>
                 &nbsp;</span>}
               
              </Grid>
              {/* <Grid item>
                <span>Content Request for:&nbsp;</span>
                <span>{data && `${_.get(data, 'requestInfo.type')}, ${_.get(data, 'requestInfo.totalCount')} Question`}</span>
              </Grid>
              <Grid item>
                <span>Deadline:&nbsp;</span>
                <span>{data && dateService.dateFromString(data.requestInfo.endDate)}</span>
              </Grid> */}
            </Grid>
          {this.renderContentRequestFor()}
            {/* <Grid container justify="space-between" alignItems="center">
              {requestType === 'test' && <Grid item>
                <span>Request 2: Test Compilation, &nbsp;</span>
                <span>{`${_.get(data, 'requestInfo.totalCount')} Test`}</span>
              </Grid>}
              <Grid item>
                <span>Test Type:&nbsp;</span>
                <span>{data && _.get(data, 'requestInfo.details.testDetails.name')}</span>
              </Grid>
              <Grid item>
                <span>Deadline:&nbsp;</span>
                <span>{data && dateService.dateFromString( _.get(data, 'requestInfo.endDate'))}</span>
              </Grid>
            </Grid> */}
          </CardContent>
          <Grid container alignItems="center"
            justify="space-between"
            className={classes.requestCardFooter}>
            <Grid item>
              <Grid container justify="flex-start" alignItems="center" className="priorityBox">
                <span><img src={`${this.getIconBasedOnPriority(_.get(data, 'requestInfo.priority', ''))}`} alt="request" /></span>
                &nbsp;<span>Priority:</span>
                &nbsp;<span >{_.get(data, 'requestInfo.priority', '').length > 0 ?
                               this.transformPriorityText(_.get(data, 'requestInfo.priority', '')):
                               'N/A'}</span>
                {/* {this.props.activeTab === Tabs.ReceivedRequest && <Button onClick={() => { this.handleOnClick() }}> Start</Button>} */}
              </Grid>
            </Grid>
            {/* @frontend use this for Rquest status */}
            {/* <Grid item>
              <Grid container justify="flex-end">
                <Grid item>
                  <span className={classes.progressLabel}> Request Status:</span>
                </Grid>
                <Grid item>
                  <LinearProgress
                  variant="determinate"
                  classes={{
                    colorSecondary: classes.colorprimary,
                    barColorPrimary: classes.colorprimary,
                    bar: classes.progressBar, root: classes.linearProgressBar1
                  }}/>
                </Grid>    
                <Grid item>
                  <span className={classes.progressPercent}> 100%</span>
                </Grid>            
              </Grid>
            </Grid>         */}
            {/* End */}

          </Grid>
        </Card>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
  user: state.loginData.userData.authenticatedUser,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setAccordianState: contentRequestAccordianActions.setAccordianState,
  setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
  setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
  deleteContentRequest,
  setTestAccordian: contentRequestAccordianActions.setTestAccordian,
  setIsBothTabOpen: contentRequestAccordianActions.setIsBothTabOpen,
	getReceivedContentRequest:getReceivedContentRequest,
	selectAllCheckbox: selectAllCheckbox
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(RequestCard)));